import { render, staticRenderFns } from "./salaryTemplateAddDialog.vue?vue&type=template&id=1d9d781a&scoped=true&"
import script from "./salaryTemplateAddDialog.vue?vue&type=script&lang=js&"
export * from "./salaryTemplateAddDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9d781a",
  null
  
)

export default component.exports